module.exports = __webpack_public_path__ + "img/Icon feather-map-pin.f4f37ece.svg";